/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { PlayHubRedirect } from '@/app/router/PlayHubRedirect'
import { RequireAuth } from '@/app/router/RequireAuth'

/**
 * THE TWO ROUTES UNDER `/play`, AND THE ONE THAT NO LONGER RENDERS.
 *
 * `/play/games` is the match board — signed-in, behind RequireAuth, called whatever
 * PLAY_BOARD_NAME currently says ("Find a game", owner 2026-09-07).
 *
 * `/play` was the public marketplace hub. The owner took it out of service the same day
 * ("хаб... не нужная страница"), and the route is KEPT rather than deleted because the
 * URL is indexed and still linked from the footer, About, Solutions and the public
 * drawer — deleting it would have turned every one of those into a 404. It answers with
 * a redirect whose target depends on who is asking; PlayHubRedirect says why.
 *
 * TO PUT THE HUB BACK: uncomment the lazy import below, swap `<PlayHubRedirect />` for
 * `<PlayHubPage />`, and restore '/play' in scripts/generate-sitemap.mjs. The page and
 * all its sections are untouched in pages/play/. The owner said "пока" — for now.
 */
// const PlayHubPage = lazy(() => import('@/pages/play/Page').then((m) => ({ default: m.PlayHubPage })))
const PlayPage = lazy(() => import('@/features/play/PlayPage').then((m) => ({ default: m.PlayPage })))

export function playRoutes() {
  return (
    <>
      <Route path="/play" element={<PlayHubRedirect />} />
      <Route
        path="/play/games"
        element={
          <RequireAuth>
            <PlayPage />
          </RequireAuth>
        }
      />
    </>
  )
}
